import styled from '@emotion/styled';
import { SeedlangIcon, StreakIcon } from '@seedlang/icons';
import { AppUI } from '@seedlang/state';
import { isPresent } from '@seedlang/utils';
import LeagueBadgeIcon from 'components/league/league_badge_icon';
import NotificationMessage from 'components/notification/notification_message';
import Paginator from 'components/paginator';
import SiteProfileImage from 'components/site_profile_image';
import Text from 'components/text';
import UserProfileImage from 'components/user/user_profile_image';
import { observer } from 'mobx-react';
import React from 'react';

const Wrapper = styled.div`
  .seedlang-icon {
    margin-right: 10px;
    border-radius: 50%;
    border: 1px solid green;
    svg {
      width: 52px;
    }
  }
`;

const Notification = styled.div`
  background: ${props => props.background};
  display: flex;
  align-items: center;
  padding: 5px;
  font-size: 14px;
  line-height: 18px;
  border-bottom: 1px solid #CCC;
  text-align: left;
`;

const MessageWrapper = styled.div`
  flex: 1;
`;

const PaginatorWrapper = styled.div`
  padding: 0 5px 5px 5px;
`;

const LeagueBadgeWrapper = styled.div`
  margin: 0 8px 0 2px;
  width: 52px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    width: 52px;
    height: 52px;
  }
`;

const StreakWrapper = styled.div`
  width: 45px;
  height: 45px;
  margin: 7px;
  background: #FFF;
  border-radius: 200px;
  border: 3px solid orange;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ImageWrapper = styled.div`
  width: 64px;
`;

@observer
class NotificationIndex extends React.Component {

  render() {
    return (
      <Wrapper>
        {
          isPresent(this.props.notifications) && this.props.notifications.map(item => {
            return (
              <Notification
                background={item.seen ? 'FFF' : '#edf2fa'}
                key={item.id}
              >
                <ImageWrapper>
                  {
                    item.notifiableType === 'Streak' ? (
                      <StreakWrapper>
                        <StreakIcon
                          width='17px'
                          top='-3px'
                          full
                          hideStreakNumber
                        />
                      </StreakWrapper>
                    ) : item.primarySender ? (
                      <UserProfileImage
                        clickToProfile
                        user={item.primarySender}
                        width={52}
                        margin='0 10px 0 0'
                      />
                    ) : item.leagueLevel ? (
                      <LeagueBadgeIcon
                        leagueLevelPosition={item.leagueLevel.position}
                        width='50px'
                        height='50px'
                        margin='-5px 0 0 0'
                      />
                    ) : AppUI.site.isDefault ? (
                      <SeedlangIcon />
                    ) : (
                      <SiteProfileImage
                        site={AppUI.site}
                        width={52}
                        margin='0 10px 0 0'
                      />
                    )
                  }
                </ImageWrapper>
                <MessageWrapper>
                  <NotificationMessage
                    notification={item}
                  />
                  <Text
                    italic
                    color='#777'
                    fontSize='13px'
                  >
                    {item.createdAt && item.createdAt.relativeTime}
                  </Text>
                </MessageWrapper>
              </Notification>
            );
          })
        }
        {
          isPresent(this.props.notifications) &&
          <PaginatorWrapper>
            <Paginator
              compact
              onClickScrollToTop
              store={this.props.store}
            />
          </PaginatorWrapper>
        }
      </Wrapper>
    );
  }
}

export default NotificationIndex;
